import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyBkPoi5nGy50SduuW92SRZp6fu9vwMMFK0",
  authDomain: "yolla-food.firebaseapp.com",
  databaseURL: "https://yolla-food-default-rtdb.firebaseio.com",
  projectId: "yolla-food",
  storageBucket: "yolla-food.firebasestorage.app",
  messagingSenderId: "847190932442",
  appId: "1:847190932442:web:a6a2f2f7f9f0e32feb5ee3"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const database = getDatabase(app);
export default app;
